import Swiper from 'swiper/bundle';
import videojs from "video.js";

$(document).ready(function () {
    let wWidth = $(window).width();
    let swipers = [];

    initializeSwipers();

    $(window).on('resize', function () {
        if ($(window).width() !== wWidth) {
            wWidth = $(window).width();
            swipers.forEach(swiper => swiper.destroy(true, true));
            swipers = [];
            initializeSwipers();
        }
    });

    function initializeVideoInstance(index, swiperInstance) {
        let swiperContainer = swiperInstance.el;
        let videoSlide = $(swiperContainer).find('.swiper-slide').eq(index);
        let nthChild = index + 1;

        let videoBox = videoSlide.find('.video-js-box');

        let currentVideoInstance = swiperInstance.videoInstance;
        if (currentVideoInstance) {
            currentVideoInstance.pause();
            currentVideoInstance.dispose();
            swiperInstance.videoInstance = null;
        }

        $(swiperContainer).find('.swiper-slide:not(:nth-child(' + nthChild + ')) .video-js-box').html('');

        if (videoBox.length > 0) {
            let videoFile = videoBox.data('video');
            let videoId = videoBox.attr('id');

            videoBox.html('<video preload="auto" id="video_' + videoId + '" class="video-js bg-img vjs-theme-revocit" autoplay muted playsinline data-setup=\'{"controls": false, "disablePictureInPicture" : true, "controlBar" : false }\'><source src="' + videoFile + '" type="video/mp4"></video>');
            swiperInstance.videoInstance = videojs('video_' + videoId);

            // Listen for the 'ended' event on the video element
            swiperInstance.videoInstance.on('ended', function () {
                // When the video ends, advance the swiper to the next slide
                swiperInstance.slideNext();
            });
        } else {
            // If no video, set a timer to slide to next after 8 seconds
            clearTimeout(swiperInstance.slideTimer);
            swiperInstance.slideTimer = setTimeout(function () {
                swiperInstance.slideNext();
            }, 8000);
        }

        const slidesCount = $(swiperContainer).find('.swiper-slide').length;

        // Autoplay video if one slide
        if (slidesCount === 1) {
            if (videoBox.length > 0) {
                let videoFile = videoBox.data('video');
                let videoId = videoBox.attr('id');

                videoBox.html('<video preload="auto" id="video_' + videoId + '" class="video-js bg-img vjs-theme-revocit" autoplay loop muted playsinline data-setup=\'{"controls": false, "disablePictureInPicture" : true, "controlBar" : false }\'><source src="' + videoFile + '" type="video/mp4"></video>');
                swiperInstance.videoInstance = videojs('video_' + videoId);
            }
        }
    }

    function initializeSwipers() {
        $('.video-slider-type-3.swiper-container').each(function (index, element) {
            let videoSwiper = new Swiper(element, {
                slidesPerView: 1,
                loop: true,
                rewind: true,
                speed: 500,
                updateOnWindowResize: true,
                pagination: {
                    el: $(element).closest('.section-video-slider-type-3').find('.swiper-pagination')[0],
                    clickable: true,
                },
                grabCursor: true,
                effect: "creative",
                creativeEffect: {
                    prev: {
                        shadow: true,
                        translate: [0, 0, -400],
                    },
                    next: {
                        translate: ["100%", 0, 0],
                    },
                },
                on: {
                    init: function (swiper) {
                        initializeVideoInstance(0, swiper);
                    },
                    slideChange: function (swiper) {

                    },
                    slideChangeTransitionEnd(swiper) {
                        initializeVideoInstance(swiper.activeIndex, swiper);


                        const activeSlide = swiper.slides[swiper.activeIndex];
                        const mediaBox = activeSlide && activeSlide.querySelector('.media-box')
                        const id = mediaBox && mediaBox.getAttribute('data-id') || 0

                        id &&  document.dispatchEvent(new CustomEvent("slideChangeVideoSlider", {
                            detail: {
                                active: id,
                                swiper: swiper
                            }
                        }));
                    }
                },
            });

            videoSwiper.videoInstance = null;
            videoSwiper.slideTimer = null;
            swipers.push(videoSwiper);
        });
    }
});
